import appConfig from '@src/app.config'

import { convertLinkToBackEnd } from '../utils/url'

export * from './_config'
export * from './_siderbar'
export * from './_type'
export * from './_access'

export function getTitle() {
  return window.config.title
}
//login header
export function getDescription() {
  return window.config.description
}
export function getNavbarTitle() {
  return window.config.title
}
export function getAppName() {
  return window.config.title
}
export function getVersion() {
  return window.config.version
}

export function getSprite() {
  return convertLinkToBackEnd(
    process.env.VUE_APP_SPRITE_URL || appConfig.map.sprite
  )
}

export function getGlyphs() {
  return convertLinkToBackEnd(
    process.env.VUE_APP_GLYPHS_URL || appConfig.map.glyphs
  )
}
export function getCopyright() {
  return window.config.copyright
}
export function getGeoServerUrl() {
  return !window.config.geoServerUrl
    ? convertLinkToBackEnd(process.env.VUE_APP_GEO_SERVER)
    : window.config.geoServerUrl
}
export function getCurrentUrl() {
  return !window.config.currentUrl
    ? convertLinkToBackEnd(
        !process.env.VUE_APP_URL || process.env.VUE_APP_URL == '/'
          ? window.location.origin
          : process.env.VUE_APP_URL
      )
    : window.config.currentUrl
}
export function getGeoServerWorkspace() {
  return (
    process.env.VUE_APP_GEO_SERVER_WORKSPACE ||
    window.config.geoServerWorkspace ||
    'cuuho'
  )
}
